// Estado de la cuenta de un vendedor que aún no puede usar el panel.
// aprobado: true + activado: false → un administrador la suspendió
// aprobado: false (y no reenviada)   → solicitud rechazada
// cualquier otro caso                → en revisión
export const estadoVendedor = (userData) => {
  if (userData?.aprobado === true) {
    return {
      tipo: "suspendida",
      nivel: "error",
      titulo: "Tu cuenta de vendedor está suspendida",
      descripcion: `${
        userData.motivoBloqueo ? `Motivo: ${userData.motivoBloqueo}. ` : ""
      }No puedes usar el panel de vendedor ni publicar. Contáctanos en ayuda@blizu.com.mx para revisar tu caso. Mientras tanto puedes comprar normalmente.`,
    };
  }
  if (userData?.aprobado === false && userData?.reenviado !== true) {
    return {
      tipo: "rechazada",
      nivel: "warning",
      titulo: "Tu solicitud de vendedor fue rechazada",
      descripcion: userData.motivoRechazo
        ? `Motivo: ${userData.motivoRechazo}. Corrige tus documentos y vuelve a enviarlos.`
        : "Corrige tus documentos y vuelve a enviarlos.",
      enlace: "/perfil/verificacion",
    };
  }
  return {
    tipo: "revision",
    nivel: "info",
    titulo: "Tu cuenta de vendedor está en revisión",
    descripcion:
      "Estamos validando tus documentos (INE y Constancia Fiscal). Mientras tanto, puedes comprar productos y servicios normalmente en Blizu. El proceso toma de 24 a 48 horas.",
  };
};
